import React from "react";
import "../../App.css";
import ContactForm from "../Contactform";

function Contact() {
  return (
    <>
      <div className="contact">
        <div className="contact-container">
          <ContactForm />
        </div>
      </div>
    </>
  );
}

export default Contact;
